import styled from 'styled-components'

import { theme } from '../../../theme'

export const FooterContainer = styled.div`
  background: ${theme.colors.white};
  border-top: 1px solid ${theme.colors.borderColor};
  box-shadow: 0px -2px 4px 0px ${theme.colors.footerShadow};
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 2rem;
  width: 100%;
`

export const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
`

export const NavigationButton = styled.button`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.colors.white};
  border: 1px solid ${theme.colors.borderColor};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: ${theme.colors.primaryDefault};

  &:hover:not(:disabled) {
    background: ${theme.colors.secondaryHover};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const IndexText = styled.p`
  font-family: ${theme.fonts.mainFont};
  font-weight: ${theme.fontWeight.medium};
  font-size: 16px;
  color: ${theme.colors.primaryDefault};
  margin: 0;
  text-align: center;
  flex: 1;
`
